var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBlacklist = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18.005,
    viewBox: "0 0 14 18.005",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_blacklist",
    d: "M611.063,354.224H609.8a1.769,1.769,0,0,0-2.237-1.022,1.72,1.72,0,0,0-1.058,1.022h-1.266a.573.573,0,0,0-.584.562h0v2.248a.574.574,0,0,0,.583.563h5.833a.573.573,0,0,0,.583-.563h0v-2.251a.573.573,0,0,0-.586-.56h0Zm2.925,16.881h-11.7a1.143,1.143,0,0,1-1.141-1.129v-13.5a1.152,1.152,0,0,1,1.17-1.129h1.164v1.691a1.72,1.72,0,0,0,1.748,1.686h5.828a1.731,1.731,0,0,0,1.754-1.686v-1.691h1.2a1.137,1.137,0,0,1,1.137,1.129v13.531A1.139,1.139,0,0,1,613.988,371.105Zm-8.314-9.854a1.015,1.015,0,0,0-.709.291,1,1,0,0,0,0,1.414l1.767,1.766-1.767,1.767a1,1,0,1,0,1.419,1.418l1.766-1.771,1.768,1.771a1,1,0,0,0,1.7-.711,1,1,0,0,0-.293-.707l-1.766-1.767,1.766-1.766a1,1,0,0,0-.709-1.7.983.983,0,0,0-.7.291l-1.768,1.766-1.771-1.766A1,1,0,0,0,605.674,361.251Z",
    transform: "translate(-601.148 -353.1)",
    fill: "#8d939c"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBlacklist);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_blacklist.41f59bbd4b3438c8e76f3e6b8ee49494.svg";